/**
 * 保险路由
 */
 export default [
    {
      path: '/settings/insuranceSetting',
      component: resolve => require(['../../views/settings/insuranceSetting'], resolve),
      meta: { title: '保险配置' }
    },
    {
      path: '/insurance/insuranceProduct',
      component: resolve => require(['../../views/insurance/insuranceProduct'], resolve),
      meta: { title: '保险产品' }
    },
    {
      path: '/insurance/insuranceList',
      component: resolve => require(['../../views/insurance/insuranceList'], resolve),
      meta: { title: '保险列表' }
    },
    
  ]
  


// WEBPACK FOOTER //
// ./src/SRM/router/modules/insurance.js